<script setup lang="ts">
import { computed } from 'vue'
import { SCSpinner } from '@nsftx/seven-components'
import { IntegratorFrame } from '@nsftx/seven-client-retail-vue-integrator'
import { useGame, useGamesStore } from '@nsftx/seven-client-retail-vue-sgp'

const { linkCode } = defineProps<{
  linkCode: string
}>()

const { getGameLinkByCode } = useGamesStore()
const gameLink = computed(() => getGameLinkByCode(linkCode))
const { linkCode: frameId, ssbtUrl } = useGame(gameLink)
</script>

<template>
  <IntegratorFrame
    v-if="frameId && ssbtUrl"
    :id="frameId"
    :key="frameId"
    :url="ssbtUrl"
    :keep-alive="30000"
  >
    <template #default="{ isLoading }">
      <SCSpinner v-if="isLoading" />
    </template>
  </IntegratorFrame>
</template>
